import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Masonry from 'react-masonry-css';
import InfiniteScroll from 'react-infinite-scroller';

import ArenaMemberItem from 'components/medlemmer/ArenaMemberItem';
import { loadItems } from 'ducks/memberlist';
import Loading from 'components/Loading';
import { MemberShape } from 'utils/shapes';
import { gettext } from 'utils/text';

const mapStateToProps = (state) => ({
    items: state.itemIds.map((item) => state.items[item]),
    hasMore: state.hasMore,
    startLoad: state.startLoad,
});

const mapDispatchToProps = (dispatch) => ({
    onLoadItems: () => dispatch(loadItems()),
});

const MembersList = ({ onLoadItems, hasMore, items, startLoad }) => {
    const emptyState = (
        <div className="jumbotron text-center">
            {gettext('Nothing was found. Choose another category or try searching for something else.')}
        </div>
    );

    const renderItems = () => (
        <InfiniteScroll
            initialLoad={false}
            pageStart={0}
            loadMore={onLoadItems}
            hasMore={hasMore}
            loader={
                <div className="arena__loading" key={0}>
                    <Loading />
                </div>
            }
        >
            <Masonry
                breakpointCols={{
                    default: 3,
                    1200: 2,
                    768: 1,
                }}
                className="arena__masonry"
                columnClassName="arena__masonry__column"
            >
                {items.map((item) => (item ? <ArenaMemberItem key={item.id} item={item} /> : null))}
            </Masonry>
        </InfiniteScroll>
    );

    if (startLoad) {
        return <div className="jumbotron text-center">{gettext('Loading… please wait')}</div>;
    }

    return items.length ? renderItems() : emptyState;
};

MembersList.propTypes = {
    onLoadItems: PropTypes.func.isRequired,
    hasMore: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(MemberShape).isRequired,
    startLoad: PropTypes.bool.isRequired,
};

const MembersView = connect(mapStateToProps, mapDispatchToProps)(MembersList);

export default MembersView;



// WEBPACK FOOTER //
// ./src/components/medlemmer/MembersView.js